import Navbar from "@/components/Navbar";
import SEO from "@/components/SEO";
import Hero from "@/components/Hero";
import Tagline from "@/components/Tagline";
import About from "@/components/About";
import Packages from "@/components/Packages";
import Gallery from "@/components/Gallery";
import HighlightVideo from "@/components/HighlightVideo";
import Testimonial from "@/components/Testimonial";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Micro Wedding Venue London Ontario | Love Otherwise"
        description="A design-forward wedding venue for modern couples. Intimate, intentional celebrations for all love stories."
        canonical="/"
      />
      <Navbar />
      <Hero />
      <Tagline />
      <About />
      <HighlightVideo />
      <Packages />
      <Gallery />
      <Testimonial />
      <Contact />
      <Footer />
    </div>
  );
};

export default Index;
